import {
  Stack,
  MenuItem,
  listItemIconClasses,
  Autocomplete,
  autocompleteClasses,
  buttonBaseClasses,
  inputBaseClasses,
  outlinedInputClasses
} from "@mui/material";
import styled from "@emotion/styled";
import { styledTextFieldClasses, StyledTextField } from "../text-field/HyroTextField.styles";

export const StyledChipContainer = styled(Stack,
  { shouldForwardProp: (prop) => prop !== "showAllChips" })(() => ({
  flexDirection: "row",
  flexWrap: "wrap",
  gap: "8px",
  maxHeight: "120px",
  overflow: "auto",
  paddingRight: "8px",
  [`& .${styledTextFieldClasses.copyIcon}`]: {
    display: "none",
  },
  [`&:hover .${styledTextFieldClasses.copyIcon}`]: {
    display: "block"
  }
}));

export const PopperContainer = styled(Stack)(({ theme }) => ({
  position: "relative",
  maxHeight: "210px",
  overflow: "scroll",
  gap: theme.spacing(1),
  padding: theme.spacing(1.5),
  borderRadius: "8px",
  backgroundColor: "#fff",
  boxShadow: theme.shadows[4]
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  [`& .${listItemIconClasses.root}`]: {
    minWidth: 18,
    marginRight: 8
  }
}));

const getColors = (theme) => ({
  default: {
    border: theme.palette.grey[200],
    background: theme.palette.system[0],
  },
  hover: {
    border: theme.palette.grey[400],
  },
  focused: {
    border: theme.palette.primary[500],
  },
  readonly: {
    background: theme.palette.grey[100],
  }
});

export const StyledAutocomplete = styled(Autocomplete, {
  shouldForwardProp: prop => prop !== "isFieldReadOnlyFromSpec" && prop !== "showTagsInPopper"
})`
  height: ${({ height }) => height};
  
  & .${inputBaseClasses.root} {
    height: ${({ height }) => height};
    min-height: ${({ height }) => height};
    max-height: ${({ height }) => height};
    line-height: 24px;
    background: ${({ theme, isFieldReadOnlyFromSpec }) =>
      isFieldReadOnlyFromSpec ? getColors(theme).readonly.background : getColors(theme).default.background};
  }

  ${({ showTagsInPopper }) => showTagsInPopper && `
    & .${inputBaseClasses.root}.${outlinedInputClasses.focused} {
      padding: 12px;
    }
  `}

  &.${autocompleteClasses.root} .${outlinedInputClasses.root} .${autocompleteClasses.input} {
    padding: 0 !important;
  }

  & .${autocompleteClasses.input} {
    padding: 0 !important;
    line-height: 24px;
  }

  ${({ showTagsInPopper }) => !showTagsInPopper && `
    & .${inputBaseClasses.root}.${outlinedInputClasses.focused} .${autocompleteClasses.input} {
      margin-left: 8px;
    }
  `}

  & .MuiChip-root {
    height: 32px;
    margin: 0;
    & .MuiChip-label {
      color: ${({ theme }) => theme.palette.text.primary};
    }
  }

  ${({ readOnly, disabled }) => (readOnly || disabled) && `
    & .${autocompleteClasses.endAdornment} .${buttonBaseClasses.root} {
      opacity: 0.24;
    }

    & .${autocompleteClasses.clearIndicator} {
      display: none;
    }
  `}

  ${({ isFieldReadOnlyFromSpec }) => isFieldReadOnlyFromSpec && `
    & .${inputBaseClasses.root} {
      cursor: not-allowed;
      &:hover {
        cursor: not-allowed;
      }
    }

    & .${inputBaseClasses.input} {
      cursor: not-allowed;
    }

    & .${autocompleteClasses.endAdornment} .${buttonBaseClasses.root} {
      opacity: 0.24;
      cursor: not-allowed;
    }
  `}
`;

export const StyledAutocompletetInput = styled(StyledTextField)(({ readOnly, height, showAllChips }) => ({
  [`& .${inputBaseClasses.root}`]: {
    height: readOnly || showAllChips ? "auto" : height,
    minHeight: height,
    padding: "8px 12px"
  }
}));
